import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './AutopilotSidebar.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { SupportChat } from 'components/FirstTimeExperienceModal/components/SupportChat/SupportChat'

export const AutopilotSidebar = () => {
  return (
    <div className={Styles.container}>
      <Heading level={4}>Here's what we need</Heading>
      <div className={Styles.steps}>
        <div className={Styles.step}>
          <div className={Styles.descriptionContainer}>
            <Text variant="label" color="var(--dark-40)">
              Screenshot 1
            </Text>
            <Heading level={5}>Homepage</Heading>
            <Text variant="placeholder" color="var(--dark-80)">
              Take a screenshot of your home page
            </Text>
          </div>
          <div className={Styles.imageContainer}>
            <img
              src="https://res.cloudinary.com/almanac/image/upload/v1755703048/onboarding_assets/screenshot_fallback/screenshot_2_ex6mm6.png"
              alt="Screenshot of homepage"
            />
          </div>
        </div>
        <div className={Styles.step}>
          <div className={Styles.descriptionContainer}>
            <Text variant="label" color="var(--dark-40)">
              Screenshot 2
            </Text>
            <Heading level={5}>Services / products page</Heading>
            <Text variant="placeholder" color="var(--dark-80)">
              Take a screenshot of your main services or products.
            </Text>
          </div>
          <div className={Styles.imageContainer}>
            <img
              alt="Screenshot of product page"
              src="https://res.cloudinary.com/almanac/image/upload/v1756150423/onboarding_assets/screenshot_fallback/product_screenshot_cyoiyi.png"
            />
          </div>
        </div>
        <div className={Styles.step}>
          <div className={Styles.descriptionContainer}>
            <Text variant="label" color="var(--dark-40)">
              Screenshots 3+
            </Text>
            <Heading level={5}>Any other pages (optional)</Heading>
            <Text variant="placeholder" color="var(--dark-80)">
              The more screenshots you provide that represent your brand visually, the sharper your Brand Profile and
              Brand Kit.
            </Text>
          </div>
        </div>
      </div>
      <SupportChat />
    </div>
  )
}
